<template>
  <div class="min-h-screen">
    <SiteHeader :page-name="'Change Password'" />
    <div class="mt-4 w-full m-auto">
      <ChangePasswordPanel :message="validationError" @change-password="changePassword" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAuthStore } from "@/stores/auth";
import { usePropsStore } from "@/stores/props";

const router = useRouter();
const validationError = ref("");
const authStore = useAuthStore();

const changePassword = (password: string, verifyPassword: string): void => {
  const data = new FormData();
  data.append("password", password);
  data.append("verifyPassword", verifyPassword);

  axios
    .post("/account/changepass", data)
    .then((response) => {
      if (response.data.errors != null) {
        validationError.value = response.data.errors[0].message;
      } else {
        success("Password changed!", "");

        if (authStore.forcePasswordChange) {
          authStore.forcePasswordChange = false;

          const userInfo = authStore.getUserInfo();
          const propsStore = usePropsStore();

          if (userInfo.scope === "ADMIN") {
            if (propsStore.streamline) {
              router.push({
                name: "project-list",
              });
            } else {
              router.push({
                name: "admin-dashboard",
              });
            }
          } else {
            router.push({
              name: "portal-project-list",
            });
          }
        } else {
          router.push({
            name: "my-account",
          });
        }
      }
    })
    .catch((e) => errorApi(e));
};
</script>
